import React from "react";
import Button from "./Button";
import { useNavigate } from "react-router";

export default function RecipientCard({
    logo = "",
    first_name = "",
    last_name = '',
    email = "",
    phone = "",
    address = "",
    ppt_inn = "",
    guid,
}) {
    const navigate = useNavigate();
    return (
        <div className="recipient-card">
            <div className="recipient-logo">{logo}</div>
            <div className="recipient-name">{first_name} {last_name}</div>

            <div className="recipient-row">
                <span className="recipient-label">Адрес:</span>{" "}
                <span className="recipient-value">{address}</span>
            </div>
            <div className="recipient-row">
                <span className="recipient-label">ИНН:</span>{" "}
                <span className="recipient-value">{ppt_inn}</span>
            </div>
            <Button onClick={() => {
                navigate("/create-recipient", {
                    state: {
                        guid: guid,
                        first_name: first_name,
                        last_name: last_name,
                        address: address,
                        ppt_inn: ppt_inn
                    }
                })
            }}>Изменить</Button>
        </div>
    );
}
